import Fuse from 'fuse.js';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinLoading from 'src/mixins/mixin-loading';
import Tables from '../class/Tables';
import i18n from 'src/i18n';

const mixinTable = {
  data() {
    return {
      rowData: null,
      fuseSearch: null,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: '',
      tableData: [],
    };
  },

  computed: {
    ...Tables.Search,
  },

  mixins: [MixinDialog, MixinLoading],

  methods: {
    searchedQuery(searchedValue) {
      this.searchQuery = searchedValue;
    },

    searchFuse(keys, data = null, threshold = 0.3) {
      this.fuseSearch = new Fuse(data ? data : this.tableData, {
        useExtendedSearch: true,
        threshold: threshold,
        keys: keys,
      });
      this.showHideLoading();
    },

    /**
     * Método para modificar las tablas de indexación de información
     * en la vista index
     * @param {Number} type
     * @param {Number} id
     * @param {*} response
     * @param {String} modal
     * @param {String} icon
     * @param {String} typeSweetAlert
     * @param {*} tableData
     * @param {boolean} code
     * @param {boolean} notification
     * @param {String} title
     */
    modifyTable(
      type,
      id,
      response,
      modal = null,
      icon = 'nc-settings-90',
      typeSweetAlert = 'warning',
      tableData = null,
      code = false,
      notification = true,
      title = 'Smart: Notificaciones...'
    ) {
      tableData = tableData ? tableData : this.tableData;
      let index = code
        ? tableData.findIndex((tableRow) => tableRow.code === id)
        : tableData.findIndex((tableRow) => tableRow.id === id);
      const beforeUpload = sessionStorage.getItem('before-upload');

      switch (type) {
        case 0:
          tableData.push(response.data.data);
          if (!beforeUpload) {
            this.closeModal('create');
            if (this.$slots.dialogForm) this.$emit('closeModal', false);
          }

          this.showHideLoading();
          if (notification) {
            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-simple-add',
              i18n.t('common_words.successful_creation_threedots')
            );
          }

          break;
        case 1:
          this.$set(tableData, index, response.data.data);
          if (!beforeUpload) {
            this.closeModal('create');
            if (this.$slots.dialogForm) this.$emit('closeModal', false);
          }

          this.showHideLoading();
          if (notification) {
            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-settings-tool-66',
              `${i18n.t('common_words.successful_update')}....`
            );
          }
          break;
        case 2:
          if (index >= 0) {
            tableData.splice(index, 1);
          }

          this.showHideLoading();
          if (notification) {
            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-simple-remove',
              i18n.t('common_words.successful_deletion')
            );
          }
          break;
        case 3:
          this.$set(tableData, index, response.data.data);
          if (modal && !beforeUpload) {
            this.closeModal(modal);
            if (this.$slots.dialogForm) this.$emit('closeModal', false);
          }

          this.showHideLoading();
          if (notification) {
            this.showNotification(
              `${response.data.message}`,
              typeSweetAlert,
              icon,
              `${i18n.t('common_words.smart_notifications')}`
            );
          }
          break;
        case 4:
          if (modal && !beforeUpload) {
            this.closeModal(modal);
            if (this.$slots.dialogForm) this.$emit('closeModal', false);
          }

          this.showHideLoading();
          if (notification) {
            this.showNotification(
              `${response.data.message}`,
              typeSweetAlert,
              icon,
              `${i18n.t('common_words.smart_notifications')}`
            );
          }
          break;
        case 5:
          this.showHideLoading();
          this.showNotification(`${response}`, typeSweetAlert, icon, title);
          break;
      }

      try {
        sessionStorage.setItem('tableCode', JSON.stringify(tableData));
      } catch (error) {}
    },
  },
};

export default mixinTable;
